module.exports = __webpack_public_path__ + "static/media/3.25136625.png";